/*
 * @Author       : 四川华西绿舍建材有限公司
 * @Date         : 2023-06-25 18:10:36
 * @LastEditTime : 2023-06-26 10:38:25
 * @LastEditors  : yangxr
 * @Description  : 
 * @FilePath     : \icps_fb\src\api\smart\reportService.js
 */
import request from "@/utils/request";
export const queryPage = "/icps/system/sign/intelligent/report/maintain/queryPage";
/*保存报告*/
export function saveOrUpdate(data) {
  return request({
    url: "/icps/system/sign/intelligent/report/maintain/saveOrUpdate",
    method: "post",
    data,
  });
}
//获取原物料管理数据
export function rawQueryPage(data) {
  return request({
    url: "icps/system/sign/basics/rawMaterials/QueryPage",
    method: "post",
    data,
  });
}
//获取详情
export function queryDetail(data) {
  return request({
    url: "icps/system/sign/intelligent/report/maintain/queryDetail",
    method: "post",
    data,
  });
}
